import {
  Locales,
  PropertyCardDetails,
  StrapiEstate,
  StrapiEstateCurrency,
} from '@monoimin/sb-types';
import {
  formatPropertyCost,
  formatPropertyLocation,
} from '@monoimin/utils/formatters';
import { getLocalePrefix } from '@monoimin/intl';

import { replaceKinstaImageUrl } from './replaceKinstImageUrl';

export function getSliderCardsFromStrapiEstates({
  properties,
  locale,
  openLinksInNewWindow,
}: {
  properties: StrapiEstate[];
  locale: Locales;
  openLinksInNewWindow?: boolean;
}) {
  const cards: PropertyCardDetails[] = properties.map((el) => {
    const cost = formatPropertyCost({
      locale,
      costTo: el?.price?.to,
      costFrom: el?.price?.from,
      currency: el.currency.toUpperCase() as StrapiEstateCurrency,
    });
    const location = formatPropertyLocation({
      countryCode: el?.country?.code,
      cityName: el?.city?.title,
      locale,
    });
    const localePrefix = getLocalePrefix(locale);

    const card: PropertyCardDetails = {
      name: el.title,
      cost,
      location,
      bedroomCount: el.bedrooms_number,
      bathroomCount: el.bathrooms_number,
      totalArea: { from: el.total_area?.from, to: el.total_area?.to, locale },
      imageUrl:
        replaceKinstaImageUrl(el.main_image?.url) ||
        replaceKinstaImageUrl(el.images?.[0]?.url),
      imageId: '',
      href: `${localePrefix}/real-estate/${el.country?.slug}/${el.slug}/`,
      linkTarget: openLinksInNewWindow ? '_blank' : '_self',
      uuid: el.slug,
    };

    return card;
  });
  return cards;
}

export default getSliderCardsFromStrapiEstates;
